import { defineStore } from 'pinia';
import actions from './actions.js';

function initState() {
    return {
        agents: {},
        companyNameById: "",
        subdomainAgents: [],
        companyInfo: {},
        defaultCompanyName: '',
        // allMls: []
    };
}

export default (storeName) => defineStore(storeName, {
    state: initState,
    actions
});
